<template>
    <div class="bottom-list-wrap" >
        <ul class="custom-scroller">
        
        <p v-for="(rule, id) in the_rule_data.activity_rules">
            <span class="num">{{id+1}}.&nbsp</span>
            <span class="text">{{rule.content}}</span>
            

        </p>

        
        </ul>
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            show: true,
            the_rule_data: {
            "title": "活動辦法",
            "activity_rules": [
                {
                "rule_id": 1,
                "content": "本活動收集卡、印花貼紙僅適用於指定日期之營業時間內兌換、使用，不可與其他活動合併使用，逾期作廢，亦不得兌換現金。收集卡、印花貼紙一張限兌換乙次，兌換後由門市人員回收。"
                },
                {
                "rule_id": 2,
                "content": "印花貼紙計算限單次、單筆交易，且預購、提貨券、門市現貨販售、大宗交易等分屬不同交易類型，各管道視為個別交易、不同發票之金額無法合併計算。印花貼紙請於收銀檯交易完成後當場清點，遺失或離櫃後恕不補發，請妥善保存。"
                },
                {
                "rule_id": 3,
                "content": "印花貼紙若有破損、無法辨識、影印者無效，偽造者依法究辦。"
                },
                {
                "rule_id": 4,
                "content": "菸品、一歲以下嬰幼兒奶粉、福利卡/電子票證儲值、代收/售、購買禮券、折價券/購物金/抵用券、印花或福利點換購皇家道爾頓商品、賣場/官網/DM/APP標示或公告之指定排除商品、全聯行動超市網路購物等，皆不列入本活動消費金額之計算。"
                },
                {
                "rule_id": 5,
                "content": "原購買商品退貨時，如扣除該商品價額未達印花贈送門檻或條件，需同時退回該筆交易溢領之印花貼紙，否則將視為商品退貨不完全，恕無法提供退貨服務。"
                },
                {
                "rule_id": 6,
                "content": "換購商品配件依型號不同，以實物為準，圖片僅供參考，庫存依門市現場為主，數量有限換完為止。若遇供貨不及或換購最後一週(2020/09/11-09/17)，本公司將統一開放提貨券預購結帳。提貨券請妥善保存並於券上載明之兌領期間內，持提貨券正本回原門市領取指定商品，提貨券遺失或逾期視為自動放棄，門市不負保管責任。"
                },
                {
                "rule_id": 7,
                "content": "換購之Royal Doulton皇家道爾頓瓷器全品項均由菲斯卡集團英國原廠設計、原廠於中國工廠生產製造，換購商品皆已通過SGS標準檢驗。"
                },
                {
                "rule_id": 8,
                "content": "本活動換購商品一經於全聯福利中心門市進行換購，印花貼紙將不予歸還，亦不接受退換貨，若為出廠瑕疵，亦僅能更換同款商品。"
                },
                {
                "rule_id": 9,
                "content": "陶瓷器商品為消耗品，恕不提供維修保固服務。換購商品須於現場檢查確認，商品離店後破損恕無法提供換貨。"
                },
                {
                "rule_id": 10,
                "content": "換購產品為手工浸潤上色，色彩所染色之角度與範圍皆為獨一無二，每一件產品的染色範圍或角度不同皆屬正常現象，非為產品瑕疵。"
                },
                {
                "rule_id": 11,
                "content": "產品為天然瓷土材質燒製而成，燒製過程中表面會產生小氣孔或者點狀物，色彩及尺寸也會因燒製條件有些微差異，皆屬正常現象，非為產品瑕疵。"
                },
                {
                "rule_id": 12,
                "content": "全聯福利中心保有最終解釋、調整與修改本活動辦法之權利，活動詳情及其他未盡事宜請至全聯官網或活動網站查詢。"
                },
                {
                "rule_id": 13,
                "content": "若對於換購之Royal Doulton皇家道爾頓瓷器商品有任何問題，請致電活動客服0800-089-860洽詢(週一至週五09:00-12:00、13:30-17:30，國定例假日除外)。"
                }
            ]
            }
        }
    },
    props: ['rule_datas'],
    methods: {
        ct_scroll(){
            $(".custom-scroller").mCustomScrollbar({
                theme: "rounded-dots",
                mouseWheelPixels: 80,
                scrollInertia: 0
            });

        }
    },
    created(){
        setTimeout(()=>{
            $(".custom-scroller").css("opacity", "1"); 
            this.ct_scroll();
        },150);
    },
    mounted() {
        
    }
}



</script>
<style lang="sass">
.custom-scroller
    transition: .3s
</style>


// WEBPACK FOOTER //
// src/ActRules/list.vue